import React, { Component } from 'react';

import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { channelActions } from '../../../_actions';

import Webview from '../../../_assets/webview-logo.png';

import moment from 'moment';

class WebviewModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      domain_uuid: JSON.parse(sessionStorage.getItem('selected_domain')).uuid
    }

    this.closeModal = React.createRef();

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    const { activeChannels } = this.props;

    activeChannels.forEach(element => {
      if (element.channel_type === 'SUPERARE_WEBVIEW') {

      }
    });

    this.props.activeChannels.forEach(element => {
      if (element.channel_type === 'SUPERARE_NOTIFICATION') {
        this.setState({
          domain: element.domain, 
          welcome_title: element.welcome_title, 
          appToken: element.appToken,
          notificationsEnabled: element.notificationsEnabled, 
          client_id: element.client_id, 
          chrome_app_id: element.chrome_app_id,
          uuid: element.uuid
        })
      }
    });
  }

  handleChange(e) {

  }

  handleSubmit(e) {
    e.preventDefault();

    let self = this;

    const { dispatch, actionType } = this.props;
    const { domain_uuid } = this.state;
    
    this.setState({submitting: true});
    
    if ( !domain_uuid ) 
      return this.setState({submitting: false});

    let obj = {
      "channel": {
        "domain_uuid": domain_uuid,
        "channel_type": "SUPERARE_WEBVIEW",
        "properties": {}
      }
    }

    if (actionType === 'view')
      return false

    let action
    let constant
    
    if (actionType === 'edit') {
      // If superare channel need edit function
      // obj.channel['uuid'] = uuid;

      action = channelActions.update(obj);
      constant = 'UPDATE_INTEGRATION_FAILURE';
    } else {
      action = channelActions.create(obj);
      constant = 'CHANNEL_INTEGRATION_FAILURE';
    }

    dispatch(action)
      .then(res => {
        if ( res.type !== constant ) {
          this.props.evt.handleSubmit();

          const data = res.data.data;

          self.setState({
            submitting: false, 
            domain: data.domain, 
            welcome_title: data.welcome_title, 
            appToken: data.appToken,
            notificationsEnabled: data.notificationsEnabled, 
            client_id: data.client_id, 
            chrome_app_id: data.chrome_app_id,
          });
  
          return toast.success(res.data.message, {
            position: toast.POSITION.TOP_RIGHT,
            className: 'toast-success'
          });
        }
  
        self.setState({submitting: false})
  
        return toast.error(res.data.message, {
          position: toast.POSITION.TOP_RIGHT,
          className: 'toast-error'
        });
      });

    //Add this code after create service 
    //this.props.evt.handleSubmit();
  }

  render() {
    const { submitting } = this.state;
    const { actionType, name } = this.props;

    let title;
    let subtitle;
    let button;
    let buttonLoading;

    switch (actionType) {
      //Add this code after edit service
      // case 'edit':
      //   title = 'Editing Webview channel'
      //   subtitle = 'It is necessary that you provide your Webview appId in the field below.'
      //   button = 'Edit Webview channel'
      //   buttonLoading = 'Editing...'
      //   break;
      case 'view':
        title = 'Webview channel information for this Domain'
        subtitle = 'Here you can you find the configured information for this channel.'
        break;
      default:
        title = 'Adding Webview channel'
        subtitle = "You're enabling notifications via Webview Channel. Are you sure?"
        button = 'Add Webview channel'
        buttonLoading = 'Adding...'
        break;
    }

    return (
      <div className="modal fade" id={name+'Modal'} tabIndex="-1" role="dialog" aria-labelledby={name+'ModalLabel'} aria-hidden="true">
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-body">
              <img src={Webview} alt="Webview logo"/>
              <br/>
              <br/>
              <p className="title">{title}</p>
              <p className="disclaimer">{subtitle}</p>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close" ref={this.closeModal}>
                <i className="lnr lnr-cross"></i>
              </button>
              {
                actionType !== 'view' ?
                <form action="#" className="form clearfix" id="superareChannelForm" method="POST" onSubmit={this.handleSubmit}>
                    {
                      submitting ?
                        <button type="button" className="btn btn-blue float-right disabled" disabled>
                          <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                          <span className="sr-only"> {buttonLoading}</span>
                        </button>    
                      : <button type="submit" className="btn btn-blue float-right">{button}</button>
                    }
                  </form>
                  : <p>Channel added!</p>
              }
              {
                actionType ?
                  <p className="edit">Last update: {moment(this.state.updated_at).format('MMMM Do YYYY, h:mm:ss a')}</p>
                : ''
              }
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  const { channelStatus } = state.createChannel;
  return channelStatus;
}

const ConnectedWebviewModal = connect(mapStateToProps)(WebviewModal);
export { ConnectedWebviewModal as WebviewModal }